import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
import "vuetify/dist/vuetify.min.css";
import MaterialKit from "./plugins/material-kit";
import mdiVue from "mdi-vue/v2";
import * as mdijs from "@mdi/js";
import "@/assets/local.css";
import store from "./store";
import InfiniteLoading from "vue-infinite-loading";
import "@/utils/initFb";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDIAzdu1Wxocw60ylyCvAMwIuxf3zTil7Q",
  authDomain: "vlearning-db949.firebaseapp.com",
  projectId: "vlearning-db949",
  storageBucket: "vlearning-db949.appspot.com",
  messagingSenderId: "475655753950",
  appId: "1:475655753950:web:cdd435c02fd3ff8d90324f",
  measurementId: "G-WGWPM0X5DP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
Vue.prototype.$firebase = app;
Vue.prototype.$analytics = analytics;
Vue.prototype.$logEvent = logEvent;
// import VueSocialSharing from "vue-social-sharing";
// import VueSocials from "vue-socials";
import i18n from "../src/plugins/i18n";
import FlagIcon from "vue-flag-icon";

Vue.use(FlagIcon);
Vue.config.productionTip = false;
// Vue.use(VueSocials);
// Vue.use(VueSocialSharing);
Vue.use(InfiniteLoading, {
  props: {
    spinner: "default"
    /* other props need to configure */
  },
  system: {
    throttleLimit: 50
    /* other settings need to configure */
  }
});

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(MaterialKit);
Vue.use(ElementUI, { locale });
Vue.use(mdiVue, {
  icons: mdijs
});

const vuetify = new Vuetify();

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

if (process.env.VUE_APP_BASE_VERSION !== "local") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
}

new Vue({
  router,
  vuetify,
  icons: mdijs,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
